import * as React from 'react';
import { clsx } from 'clsx';
import { Draggable } from 'react-beautiful-dnd';

import { useDraggableInPortal } from './useDraggableInPortal';
import * as style from './DraggableHeaderCell.css';

export interface IDraggableHeaderCellProps {
  draggableId: string;
  index: number;
  portalElement: HTMLElement | null;
  published?: boolean;
}

export const DraggableHeaderCellComponent = (
  props: React.PropsWithChildren<IDraggableHeaderCellProps>,
): React.JSX.Element => {
  const { children, published = true, draggableId, index, portalElement } = props;
  const renderDraggable = useDraggableInPortal(portalElement);

  return (
    <Draggable draggableId={draggableId} index={index}>
      {renderDraggable(provided => (
        <div
          className={style['head-cell-container']}
          ref={provided.innerRef}
          {...provided.dragHandleProps}
          {...provided.draggableProps}
        >
          <div className={clsx(style['head-cell'], !published && style['head-cell--unpublished'])}>{children}</div>
        </div>
      ))}
    </Draggable>
  );
};

export const DraggableHeaderCell = React.memo(DraggableHeaderCellComponent);
